import { InboxNotiUnreadCountResponseDto } from '@diritto/common/notification/dtos/inbox-noti.response.dto';
import { useQuery } from '@tanstack/react-query';
import { NotiApi } from 'api/ApiHelper';
import { notiQueryKey } from 'queries/noti/queryKey';

export const useGetInboxNotiUnreadCountQuery = (enabled = false) =>
  useQuery<InboxNotiUnreadCountResponseDto>({
    queryKey: notiQueryKey.unreadCount(),
    queryFn: () => NotiApi.getInboxNotiUnreadCount(),
    enabled,
  });
